import { ThemeProvider } from "@material-ui/styles";
import React from "react";
import GraphqlProvider from "../../graphql/GraphqlProvider";
import { StoreProvider } from "../../redux";
import { SecurityProvider } from "@iolabs/keycloak";
import iolabsTheme, { GlobalCss } from "../../utils/Theming";
import { LanguageProvider } from "@iolabs/language-provider";
import { GlobalDialogProvider } from "@iolabs/wip-dialog";
import { App } from "@iolabs/app";
import PageRouter from "../../pages/PageRouter";
import de from "./../../translations/de.json";
import en from "./../../translations/en.json";

interface IProps {}

class AppWrapper extends React.Component<IProps> {
    public render() {
        return (
            <StoreProvider>
                <SecurityProvider initConfig={{ onLoad: "login-required", checkLoginIframe: false }}>
                    <ThemeProvider theme={iolabsTheme}>
                        <GraphqlProvider>
                            <LanguageProvider
                                defaultLocale={"de"}
                                messages={{
                                    de,
                                    en,
                                }}
                            >
                                <GlobalDialogProvider>
                                    <App globalCss={<GlobalCss />}>
                                        <PageRouter />
                                    </App>
                                </GlobalDialogProvider>
                            </LanguageProvider>
                        </GraphqlProvider>
                    </ThemeProvider>
                </SecurityProvider>
            </StoreProvider>
        );
    }
}

export default AppWrapper;
